/**
 * AI Configuration Management (system-wide)
 * Domain profiles, generic intents, RAG categories, prompt templates.
 * Admin only. Intents (per bot) are under /:tenantSlug/bots/:botId
 */
import { useState } from 'react';
import {
  AiConfigTabBar,
  type AiConfigTab,
  DomainProfilesTab,
  GenericIntentsTab,
  RagCategoriesTab,
  PromptTemplatesTab,
} from '../components/aiconfig';

export function AiConfig() {
  const [tab, setTab] = useState<AiConfigTab>('domains');

  return (
    <div className="h-full w-full overflow-y-auto bg-gray-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">AI Configuration</h1>
        <p className="text-gray-600 mb-8">
          System-wide config: domain profiles (coarse routing), generic intents (L0), RAG categories, prompt templates.
          Message bundles and RAG documents (chunks, sync) are under each bot&apos;s configuration.
        </p>

        <AiConfigTabBar tab={tab} onTabChange={setTab} />

        {tab === 'domains' && <DomainProfilesTab />}
        {tab === 'generic-intents' && <GenericIntentsTab />}
        {tab === 'rag-categories' && <RagCategoriesTab />}
        {tab === 'prompt-templates' && <PromptTemplatesTab />}
      </div>
    </div>
  );
}
